<template>
	<div class="x_box A4">
	<div class="x_body">
		<h4 class="text-center font-m">{{$t('stock_on_hand_list')}}</h4>
		<table class="table table-bordered table-striped table-sm no-bor">
			<thead>
			<tr>
				<th>{{ $t('no') }}</th>
				<th>{{ $t('barcode') }}</th>
				<th>{{ $t('name') }}</th>
				<th>{{ $t('category') }}</th>
				<th>{{ $t('uom')}}</th>
				<th>{{ $t('branch')}}</th>
				<th class="text-right">{{ $t('begin_stock')}}</th>
				<th class="text-right">{{ $t('end_stock') }}</th>
			</tr>
			</thead>
			<tbody>
			<tr v-for="(ret, index) in records" :key="index">
				<td>{{index+1}}</td>
				<td>{{ret.ItemCode}}</td>
				<td>{{ret.ItemName}}</td>
				<td>{{ret.Category}}</td>
				<td>{{ret.UomName}}</td>
				<td>{{ret.BranchName}}</td>
				<td class="text-right">{{ret.BeginStock}}</td>
				<td class="text-right">{{ret.Quantity + ret.BeginStock}}</td>
			</tr>
			</tbody>
		</table>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				records: []
			}
		},
		created() {
			this.toList();
		},
		methods: {
			toList() {
				var loading = this.$loading.show();
				var req = {
					Limit: 0
				}
				if(this.$route.query.branchid != undefined){
					req.BranchId = this.$route.query.branchid;
				}
				this.$api().post("report/stock/onhands", req).then(res => {
					this.records = res.data.Json.StockOnhands;
				}).finally(() => { loading.hide(); });
			}
		}
	}
</script>